/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryQueryListRequest {
    getFixupPrototypeFunction() { return InventoryQueryListRequest.fixupPrototype; }

    static newInstance(model: Partial<InventoryQueryListRequest>): InventoryQueryListRequest {
        let obj = Object.assign(new InventoryQueryListRequest(), model);
        InventoryQueryListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryQueryListRequest>): InventoryQueryListRequest {
        if (!model) return null;
        return InventoryQueryListRequest.newInstance(<InventoryQueryListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryQueryListRequest) {
        if (!obj) return;

        models.InventoryQueryListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryQueryListRequest): boolean {
        Object.setPrototypeOf(obj, InventoryQueryListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.InventoryQueryFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.ResourceQuerySortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.ResourceQuerySortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.InventoryQueryFilter;

}
